/** A way back returns only to Aspire, to Prove's tracks and skills
 *  (docs/PROVE_TRACKS.md) — at the site tree's addresses too, /tracks/<id>
 *  and /skills/<id> — or to a résumé (/resume, /resumes/<id>, and its own
 *  address /artifacts/<slug>), on this site. */
function safeReturnTo(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null;
  try {
    const url = new URL(value, 'https://caliber.invalid');
    if (url.origin !== 'https://caliber.invalid' || !/^\/(aspire|prove|apply|skills|tracks|resume|resumes|sources|artifacts|capture)(\/|$)/.test(url.pathname)) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch { return null; }
}

/** Skill evidence screens may return only to a track's plan on Prove, to
 *  Aspire's Your direction (whose moves open Prove and Reference), or to an
 *  older card-editor address, which redirects to its track. */
export function applyCardReturnTo(value: unknown): string | null {
  const safe = safeReturnTo(value);
  if (!safe) return null;
  const url = new URL(safe, 'https://caliber.invalid');
  // The old /apply and /skills addresses (a link sent before the rename) still count.
  // …and the résumé, whose lines ask a referee straight from the document
  // (owner call 2026-10-03)
  // THE SITE TREE (2026-10-03): a track's page (/tracks/<id>), a skill's
  // (/skills/<id>, perhaps on a track) and a résumé's (/resume, /resumes/<id>)
  return /^\/(aspire|apply)\/(current|target|direction|tracks)$/.test(url.pathname) || /^\/(prove|skills)\/tracks\/[^/]+$/.test(url.pathname)
    || /^\/tracks\/[^/]+$/.test(url.pathname) || /^\/skills\/[^/]+$/.test(url.pathname)
    || /^\/(capture\/resume|resume|resumes\/[^/]+|(?:sources|artifacts)\/[^/]+)$/.test(url.pathname) ? safe : null;
}

/** What the way back says: the résumé, the skill, else the card (the older editor addresses open a track). */
export function cardReturnLabel(returnTo: string): string {
  if (/^\/(capture\/resume|resume|resumes\/[^/?#]+|(?:sources|artifacts)\/[^/?#]+)(?=[?#]|$)/.test(returnTo)) return '← Back to your résumé';
  if (/^\/skills\/[^/?#]+(?=[?#]|$)/.test(returnTo)) return '← Back to the skill';
  return '← Back to the card';
}
